import {FETCH_SWPRAYERDETAILS} from '../actions/types';

const INTIAL_STATE = [];

export default (state = INTIAL_STATE,action) => {
    switch(action.type){
        case FETCH_SWPRAYERDETAILS:
            return action.payload;
        default:
            return state;
    }
}